import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext.js';
import { ServicPageListEN as ServicListEN, ServicPageListAR as ServicListAR } from './servicePageData.js'; // ✅ غيّر هنا – استخدم servicePageData.js الكامل
import { Helmet } from 'react-helmet';

export default function Service_Description() {
  const { slug } = useParams();
  const { language, t } = useLanguage();

  // ✅ useEffect محرّك قبل الـ if، تمام لـ ESLint
  useEffect(() => {
    // لو الخدمة مش موجودة، غيّر الـ title لـ Not Found
    const serviceEN = ServicListEN.find(item => item.slug === slug);
    const serviceTitle = serviceEN ? serviceEN.title : (language === 'ar' ? 'الخدمة غير موجودة' : 'Service not found');
    document.title = `${language === 'en' ? 'Services' : 'خدماتنا'} - ${serviceTitle}`;
    window.scrollTo(0, 0);
  }, [slug, language]);

  const serviceEN = ServicListEN.find(item => item.slug === slug);

  // ✅ أضف الـ logs هنا داخل الـ function عشان يشتغلوا
  console.log('Slug from URL:', slug); // يطبع "visual-identity-design"
  console.log('ServicListEN length:', ServicListEN ? ServicListEN.length : 'undefined'); // يطبع عدد الخدمات (16)
  console.log('Found serviceEN:', serviceEN); // يطبع الخدمة أو null

  // ✅ وعدّل الـ if هنا داخل الـ function
  if (!serviceEN) {
    console.log('Service not found for slug:', slug); // يطبع لو مش لاقي
    return (
      <div className="container py-20 text-center">
        <h2 className="text-2xl text-red-600 bg-red-100 p-4 rounded"> {/* أضف background عشان يظهر */}
          {language === 'ar' ? 'الخدمة غير موجودة! Slug: ' + slug : 'Service not found! Slug: ' + slug}
        </h2>
      </div>
    );
  }

  const service = language === 'ar'
    ? ServicListAR.find(item => item.id === serviceEN.id) || serviceEN
    : serviceEN;

  // ✅ أضف fallback لو service مش كامل
  if (!service || !service.title) {
    console.log('Service data incomplete for id:', serviceEN.id);
    return (
      <div className="container py-12">
        <h1 className="text-4xl font-bold mb-6">Service Loading...</h1>
        <p>Content will appear soon. Contact us for details!</p>
      </div>
    );
  }

  return (
    <div className="container py-12">
      <Helmet>
        <title>{(language === 'en' ? 'Services' : 'خدماتنا')} - {service.title}</title>
        <meta name="description" content={service.small_description} />
      </Helmet>

      <h1 className="text-4xl font-bold mb-6">{service.title}</h1>
      
      <img 
        src={service.img} 
        alt={service.title} 
        className="w-full h-80 object-cover rounded-lg mb-6"
        onError={(e) => {
          console.log('Image load error for:', service.img); // ✅ أضف log للصور
          e.target.src = 'https://placehold.co/1200x500/ccc/666?text=No+Image';
        }}
      />
      
      <p className="text-lg font-semibold text-indigo-600 mb-4">
        {service.small_description}
      </p>
      
      <p className="text-gray-700 leading-relaxed">
        {service.description}
      </p>
    </div>
  );
}